import createAPI from '@common/createAPI.js'

export default {
  // 稿件状态统计
  postStatisticsBase: config =>
    createAPI('/mbd-special/shendu/statistics/base', 'post', config, {}),
  // 审读稿件统计
  postStatisticsSystem: config => createAPI('/mbd-special/shendu/statistics/distribution/system', 'post', config, {}),
  // 审读稿件类型统计
  postStatisticsArticleType: config => createAPI('/mbd-special/shendu/statistics/distribution/articleType', 'post', config),
  // 审读稿件信源渠道统计
  postStatisticsFolder: config => createAPI('/mbd-special/shendu/statistics/distribution/folder', 'post', config),
  // 各机构审读统计
  postStatisticsDepartment: config => createAPI('/mbd-special/shendu/statistics/distribution/department', 'post', config),
  // 可疑数据类型统计
  postStatisticsReviewSystem: config => createAPI('/mbd-special/shendu/statistics/review/system', 'post', config),
  // 可疑数据类型统计
  postStatisticsReviewGroup: config => createAPI('/mbd-special/shendu/statistics/review/group', 'post', config),
  // 可疑内容统计
  postStatisticsReviewByType: config => createAPI('/mbd-special/shendu/statistics/distribution/reviewByType', 'post', config),
  // 审校类型稿件列表接口
  postStatisticsReviewDepartment: config => createAPI('/mbd-special/shendu/statistics/review/department', 'post', config)
}
